'use memo';

import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';
import { Suspense } from 'react';
import { VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';
import { featureFlags } from '@/lib/env';
import { ItemDetailHeader } from './-components/ItemDetailHeader';

/**
 * Item Ledger（品目台帳）詳細画面のレイアウト。
 *
 * FE-1 で配線した ITEM_LEDGER feature flag が無効な環境では 404 にする
 * （`_list.tsx` と同様の挙動）。Phase 1 はタブを持たない単一ページ構成のため、
 * ヘッダー + `<Outlet />` のみ。
 */
export const Route = createFileRoute('/_staff/item-ledger/$itemId/_layout')({
  beforeLoad: () => {
    if (!featureFlags.check('ITEM_LEDGER')) {
      throw notFound();
    }
  },
  component: Layout
});
function ItemDetailHeaderSkeleton() {
  return <VStack className="gap-3 bg-neutral-fill px-12 py-4 shadow-xs">
      <Skeleton className="h-4 w-40" />
      <VStack className="gap-2">
        <Skeleton className="h-5 w-24 rounded-full" />
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-48" />
      </VStack>
    </VStack>;
}
function Layout() {
  return <VStack className="gap-0">
      <Suspense fallback={<ItemDetailHeaderSkeleton />}>
        <ItemDetailHeader />
      </Suspense>
      <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
        <Outlet />
      </Suspense>
    </VStack>;
}